<!-- DEPARTMENT MODAL -->
<template>
  <form @submit.prevent>
    <CModal
      :title.sync="title"
      color="info"
      size="lg"
      :closeOnBackdrop="false"
      :show.sync="show"
    >
      <CRow>
        <CCol>
          <label> Department </label>
          <CRow>
            <CCol>
              <b-form-select v-model="form.department_id" :options="options" :class="errors.department_id ? 'is-invalid' : ''"></b-form-select>
                <b-form-invalid-feedback>
                  Your Department name must be filled
                </b-form-invalid-feedback>
            </CCol>
          </CRow>
          <label> Subject </label>
          <CRow>
            <CCol>
              <b-input
                v-model="form.subject" :class="errors.subject ? 'is-invalid' : ''"
              >
              </b-input>
              <b-form-invalid-feedback>
                  Your Subject must be filled
              </b-form-invalid-feedback>
            </CCol>
          </CRow>
          <label class="mt-2"> Content </label>
          <CRow>
            <CCol>
              <b-textarea rows="10"  v-model="form.content" :class="errors.content ? 'is-invalid' : ''" />
              <b-form-invalid-feedback>
                  Your Content must be filled
              </b-form-invalid-feedback>
            </CCol>
          </CRow>
          <label class="mt-2"> By </label>
          <CRow>
            <CCol>
              <b-input
                v-model="form.by" :class="errors.by ? 'is-invalid' : ''"
              >
              </b-input>
              <b-form-invalid-feedback>
                  Your name must be filled
              </b-form-invalid-feedback>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton
          v-if="mode === 'create'"
          type="submit"
          v-on:click.prevent="create()"
          variant="outline"
          color="info"
          >Create</CButton
        >
        <CButton
          v-if="mode === 'edit'"
          type="submit"
          v-on:click.prevent="update(form.id)"
          variant="outline"
          color="info"
          >Edit</CButton
        >
      </template>
      <!-- <pre>{{ $data }}</pre> -->
    </CModal>
    <modalphotobg></modalphotobg>
  </form>
</template>

<script>
import EventBus from "@/eventBus";

import department from "@/services/department";
import modalphotobg from "./modal_photo_bgimage.vue";

export default {
  name: "departmentmodal",
  components: {
    modalphotobg,
  },
  data() {
    return {
      show: false,
      title: "Default Title",
      mode: "",
      errors: {},
      errors_from_backend: [],
      form: {
        id:'',
        department_id:'',
        subject:'',
        content:'',
        by:''
      },

      options: [],
      largeModal: false,
      largeModal1: false,
      loading: false,
    };
  },
  computed: {
    
  },
  mounted() {
    this.load();
  },
  created() {
    var self = this;
    EventBus.$on("OPEN_MODAL_DEPARTMENT", (params) => {
      if (params.data) {
        department
          .getDepartmentMessagebyID(params.data)
          .then((res) => {
            self.show = true;
            self.title = params.title + params.data;
            self.mode = params.mode;
            self.form.id = res.data.id;
            self.form.department_id = res.data.department_id;
            self.form.subject = res.data.subject;
            self.form.content = res.data.content;
            self.form.by = res.data.by;
          })
          .catch((err) => {
            var params = {
              title: "Error",
              mode: "danger",
              data: err.response.data.message,
            };
            EventBus.$emit("OPEN_MODAL_ALERT", params);
          });
      } else {
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "",
        self.form.department_id = "";
        self.form.subject = "";
        self.form.content = "";
        self.form.by = "";
      }

        department.getDepartment()
        .then(res => {
            for (let i=0; i <= res.data.length-1; i++){
            this.options.push({text: res.data[i].name, value:res.data[i].id})
            }
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })

    });
  },

  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    create() {
      this.loading = true;
      if (this.check_form()) {
      department
        .createDepartmentMessage(this.form)
        .then((res) => {
          EventBus.$emit("TABLE_UPDATE_DEPARTMENT_MESSAGE", true);
          var params = { title: "Success", mode: "success", data: res.message };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
          this.show = false;
        })
        .catch((err) => {
          this.loading = false;
          alert(err.response.data.message);
          //alert(JSON.stringify(err.response.data.errors));
          if (err.response.data.errors != null) {
              this.errors_from_backend = err.response.data.errors;
              console.log(JSON.stringify(err.response.data.errors));
            }
          });
        } else {
        this.loading = false;
      }
    },

    update(id) {
      this.show = false;
      department
        .updateDepartmentMessage(id, this.form)
        .then((res) => {
          EventBus.$emit("TABLE_UPDATE_DEPARTMENT_MESSAGE", true);
          var params = { title: "Success", mode: "success", data: res.message };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        })
        .catch((err) => {
          var params = {
            title: "Error",
            mode: "danger",
            data: err.response.data.message,
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        });
    },
    check_form: function(e) {
         this.errors = {};
         if (!this.form.department_id) {
            this.errors["department_id"] = "1";
         }
         if (!this.form.subject) {
            this.errors["subject"] = "1";
         }
         if (!this.form.content) {
            this.errors["content"] = "1";
         }
         if (!this.form.by) {
            this.errors["by"] = "1";
         }

         if (
            this.form.department_id &&
            this.form.subject &&
            this.form.content &&
            this.form.by 
         ) {
            return true;
         } else {
            return false;
         }
      },
    openModalPhotoBGImage(id) {
      var params = { title: "Update BG Image", mode: "edit", data: id };
      EventBus.$emit("OPEN_MODAL_BGIMAGE_DEPARTMENT", params);
      console.log("load modal photo");
    },
  },
};
</script>

<style></style>
